import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import './LoginPage.css';
import button from "react-bootstrap/lib/Button";

class LoginForm extends Component {

  state = {
    redirect: false,
    error: false,
    instance: this
  }

  componentDidMount() {
    if (localStorage.getItem("fb_access_token")) {
        this.facebookLogin(localStorage.getItem("fb_access_token"));
    } else if (localStorage.getItem("google_access_token")) {
        this.googleLogin(localStorage.getItem("google_access_token"));
    } else {
        this.handleFacebookRedirectToken();
    }
    this.initializeGoogle();
  }

  // Handles the return trip from the Facebook OAuth dialog, which lands back
  // on this page with the access token in the URL hash. This used to run
  // inside render() (renderRedirect), which re-parsed the hash and re-called
  // facebookLogin on every re-render — including the re-render triggered by
  // a successful login's own setState. That produced a second, duplicate
  // login request racing the first one; if the second request lost the
  // race (e.g. backend treats the token as already used) it reset
  // state.error/redirect and the user was silently kept on the login page
  // instead of reaching /yantra. Doing this once in componentDidMount, and
  // stripping the hash from the URL immediately, prevents the replay.
  handleFacebookRedirectToken = () => {
      const queryString = require('query-string');
      let token;
      if (window.location && window.location.hash) {
          token = queryString.parse(window.location.hash, {ignoreQueryPrefix: true}).access_token;
      }
      if (token) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
          this.facebookLogin(token);
      }
  }

  componentWillUnmount() {
      if (this.googleInitInterval) {
          clearInterval(this.googleInitInterval);
      }
  }

  initializeGoogle = () => {
      // The Google Identity Services script (index.html) loads with async/defer,
      // so window.google may not exist yet when this component mounts. Poll until
      // it's ready instead of assuming it's already loaded.
      if (window.google && window.google.accounts && window.google.accounts.id) {
          this.renderGoogleButton();
          return;
      }
      this.googleInitInterval = setInterval(() => {
          if (window.google && window.google.accounts && window.google.accounts.id) {
              clearInterval(this.googleInitInterval);
              this.googleInitInterval = null;
              this.renderGoogleButton();
          }
      }, 100);
  }

  renderGoogleButton = () => {
      window.google.accounts.id.initialize({
          client_id: "189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com",
          callback: this.handleGoogleCredentialResponse
      });
      window.google.accounts.id.renderButton(
          document.getElementById("google-sign-in"),
          {
              type: "standard",
              theme: "outline",
              size: "large",
          }  // customization attributes
      );
      window.google.accounts.id.prompt(); // also display the One Tap dialog
  }

  facebookManualLogonCallback() {
      var redirectUri = window.location.href;
      if(redirectUri.indexOf("?") > 0) {
          redirectUri = redirectUri.substring(0, redirectUri.indexOf("?"));
      }
      window.location.href = 'https://www.facebook.com/v22.0/dialog/oauth?client_id=548346835996683&response_type=token&redirect_uri=' + redirectUri + '&scope=email&state={redirect=true}';
  }


  handleGoogleCredentialResponse = (response) => {
      var token = response.credential;
      console.log("Encoded JWT ID token: " + response.credential);
      if (!localStorage.getItem("y_jwt_token")) {
          this.googleLogin(token);
      }
  }

  facebookLogin = (token) => {
      fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/facebook/code/' + token,
          {
              method: "post",
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
              }})
          .then(res => res.json())
          .then(
              (result) => {
                  if (result.data && result.data.message && result.data.message === 'Invalid OAuth access token.') {
                      localStorage.removeItem('fb_access_token');
                      this.setState({ redirect:false, error:true })
                  } else if(result.status !== undefined) {
                      localStorage.removeItem('fb_access_token');
                      this.setState({ redirect:false, error:true })
                  } else {
                      this.googleLogout();
                      localStorage.removeItem('google_access_token');
                      localStorage.setItem('fb_access_token', token);
                      localStorage.setItem('y_jwt_token', result.jwtToken);
                      this.setState({redirect: true})
                  }
              },
              (error) => {
                  localStorage.removeItem('fb_access_token');
                  this.setState({ redirect:false, error:true })
                  console.log("error", error)
              }
          )
  }

  googleLogin = (token) => {
      fetch(process.env.REACT_APP_API_BASE_URL + '/authentication/login/google/code/' + token,
          {
              method: "post",
              headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
              }})
          .then(res => res.json())
          .then(
              (result) => {
                  if (result.data && result.data.message) {
                      this.googleLogout();
                      localStorage.removeItem('google_access_token');
                      this.setState({ redirect:false, error:true })
                  } else if(result.status !== undefined) {
                      this.googleLogout();
                      localStorage.removeItem('google_access_token');
                      this.setState({ redirect:false, error:true })
                  } else {
                      localStorage.removeItem('fb_access_token');
                      localStorage.setItem('google_access_token', token);
                      localStorage.setItem('y_jwt_token', result.jwtToken);
                      this.setState({redirect: true})
                  }
              },
              (error) => {
                  localStorage.removeItem('google_access_token');
                  this.setState({ redirect:false, error:true })
                  console.log("error", error)
              }
          )
  }

    googleLogout = () => {
        if (localStorage.getItem('google_access_token')) {
            window.google.accounts.id.disableAutoSelect();
            localStorage.removeItem('google_access_token');
            /*window.gapi.auth.authorize(
                {
                    'client_id': '189879900990-j48su5nkn32vslbc57fssmkmtsqjt7s3.apps.googleusercontent.com',
                    'scope': 'profile email',
                    'immediate': false,
                    cookie_policy: 'single_host_origin',
                    response_type: localStorage.getItem('google_access_token')
                },
                function (authResult) {
                    window.gapi.auth.signOut();
                    // localStorage.removeItem('google_access_token');
                }
            );*/
        }
    }

  render() {
    return (
      <div className="login-btn login">
          {this.state.redirect && <Redirect to='/yantra' />}
          <p>Connect with your social account</p>
          <div className='form-group facebook_btn_div'>
              <button type='button' className='kep-login-facebook metro' onClick={this.facebookManualLogonCallback}>FACEBOOK</button>
          </div>
          <div className='login-btn form-group google_btn_div'>
            <div id="google-sign-in" className="metro">GOOGLE</div>
          </div>
          <a target='_blank' rel='noopener noreferrer' href='https://play.google.com/store/apps/details?id=com.che.yantra&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
              <img className='android-logo' alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/>
          </a>
          {/*<p>or continue with</p>
          <div className='login-btn'>
            <button className='btn email' type='submit'>EMAIL</button>
          </div>*/}
      </div>
    )
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/components/LoginPage/LoginForm.js